TFM = require 'app/scripts/lib/markdown/tfm'

module.exports = new class
  markdownAsHtml: (s, args = {}) ->
    ###
    There were some old accounts that couldn't view their account page
    because they had a null bio.  That needed to be fixed, but we may
    as well not crash the client if we run into a case like this.
    ###
    s ?= ''
    if s == ''
      return s
    return TFM.description.format(s, args).output

  markdownAsText: (s, args = {}) ->
    s ?= ''
    if s == ''
      return s
    return TFM.description.text(s, args).output

  # Take a number like 9823 and convert it to "9.59 KB"
  bytes: (bytes) ->
    if !bytes?
      return "Unknown Size"

    units = ["B", "KB", "MB", "GB"]
    count = bytes
    for unit, index in units
      if count < 1024 || (index == units.length - 1)
        number = Math.round(count * 100) / 100
        return "#{number} #{unit}"
      count /= 1024

    "unknown"
